<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Pedagogica" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiPedagogica.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiPedagogica.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                    <div class="d-flex justify-content-end">
                        <b-button v-if="!isReadOnly && jsonDataAnamnesiPedagogica.id" @click="onSaveAnamnesiPedagogica"  variant="outline-success">Salva</b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiPedagogica: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiPedagogica: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiPedagogica: "/rsaschedarelazionesanitariaanamnesipedagogica",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiPedagogica() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiPedagogica + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiPedagogicaSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiFamiliareError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPedagogicaSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiPedagogica = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiPedagogicaError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiPedagogica = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onSaveAnamnesiPedagogica() {
            let me = this;
            me.jsonDataAnamnesiPedagogica.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiPedagogica.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiPedagogica, me.jsonDataAnamnesiPedagogica, me.saveSchedaRelazioneSanitariaAnamnesiPedagogicaSuccessResponse, me.saveSchedaRelazioneSanitariaPedagogicaErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiPedagogicaSuccessResponse() {
            let me = this;
            me.$bvToast.toast("Anamnesi pedagogica salvata con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.$parent.loadData();
        },
        saveSchedaRelazioneSanitariaAnamnesiPedagogicaErrorResponse() {
            console.error("Errore nel salvataggio dell'anamnesi pedagogica:");
        },
    },
};
</script>
